import PropTypes from 'prop-types';

const Trash = ({ color, size, ...props }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            d="M9 4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1H9zM7 5V4a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h4a1 1 0 1 1 0 2h-1v13a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7H3a1 1 0 0 1 0-2h4m1 2h10v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm2 3a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m5 1a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0z"
            fill={color}
            fillRule="evenodd"
        />
    </svg>
);

export default Trash;

Trash.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
